import { Dialog, DialogTitle, Divider, type DialogProps } from '@shared/components';

import { CancelExamEventLogic } from '../cancel-exam-event-logic';

export interface CancelExamEventModalProps extends Omit<DialogProps, 'onSubmit'> {
  onSubmit: (reason: string) => void;
  onClose: () => void;
}

export default function CancelExamEventModal(props: Readonly<CancelExamEventModalProps>) {
  const { onClose, onSubmit, ...restProps } = props;

  return (
    <Dialog {...restProps} maxWidth='sm' onClose={onClose}>
      <DialogTitle onClose={onClose}>ยืนยันการยกเลิกรอบสอบ?</DialogTitle>
      <Divider />
      <CancelExamEventLogic onSubmit={onSubmit} onClose={onClose} />
    </Dialog>
  );
}
